import { DownOutlined, PoweroffOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Dropdown } from "antd";
import { useLogout } from "@/modules/auth/hooks/useAuth";
import { useAuthStore } from "@/modules/auth/store/auth.store";

function initials(fullName?: string | null) {
	if (!fullName) {
		return null;
	}
	const parts = fullName.trim().split(/\s+/).slice(0, 2);
	return parts.map((part) => part[0]?.toUpperCase()).join("") || null;
}

interface UserMenuProps {
	/** `compact` renders avatar only — used in the collapsed sider. */
	variant?: "full" | "compact";
}

export function UserMenu({ variant = "full" }: UserMenuProps) {
	const user = useAuthStore((state) => state.user);
	const { mutate: logout, isPending: isLoggingOut } = useLogout();

	const items = [
		{
			key: "identity",
			label: (
				<div className="min-w-40 py-1">
					<div className="text-[13px] font-medium text-[var(--c-text)]">
						{user?.fullName ?? "Foydalanuvchi"}
					</div>
					<div className="numeric text-xs text-[var(--c-text-muted)]">{user?.phone}</div>
				</div>
			),
			disabled: true,
		},
		{ type: "divider" as const },
		{
			key: "logout",
			icon: <PoweroffOutlined />,
			label: "Chiqish",
			danger: true,
		},
	];

	return (
		<Dropdown
			menu={{
				items,
				onClick: ({ key }) => {
					if (key === "logout") {
						logout();
					}
				},
			}}
			placement={variant === "compact" ? "topRight" : "topLeft"}
			trigger={["click"]}
			disabled={isLoggingOut}
		>
			<button
				type="button"
				aria-label="Foydalanuvchi menyusi"
				// `appearance-none` + explicit bg: without them, `color-scheme: dark`
				// makes the browser paint its own native (gray) button chrome here.
				className="flex w-full appearance-none items-center gap-2.5 rounded-lg border border-transparent bg-transparent px-2 py-1.5 text-left outline-none transition-colors hover:bg-[var(--c-hover)] focus-visible:border-[var(--c-accent)] focus-visible:bg-[var(--c-hover)]"
			>
				<Avatar
					size={30}
					className="shrink-0 bg-[var(--c-accent)] text-[12px] font-semibold text-white"
					icon={initials(user?.fullName) ? undefined : <UserOutlined />}
				>
					{initials(user?.fullName)}
				</Avatar>
				{variant === "full" ? (
					<>
						<span className="min-w-0 flex-1">
							<span className="block truncate text-[13px] font-semibold leading-tight text-[var(--c-text)]">
								{user?.fullName ?? "Foydalanuvchi"}
							</span>
							<span className="numeric block truncate text-xs leading-tight text-[var(--c-text-secondary)]">
								{user?.phone}
							</span>
						</span>
						<DownOutlined className="shrink-0 text-[10px] text-[var(--c-text-muted)]" />
					</>
				) : null}
			</button>
		</Dropdown>
	);
}
